

import axios, { AxiosResponse } from "axios";
import { StudentVoteInsertDTO } from "../../models/dtos/content/StudentVoteInsertDTO";
import BaseService from "../base/BaseService";

export default class StudentSatisfactionRecordService extends BaseService {
    saveVote(dto: StudentVoteInsertDTO): Promise<any> {
        return axios.post( `/StudentVotes/SaveVote`, dto)
            .then(function (response: AxiosResponse<any>) {
                return response;
            });
    }
}